<template>
  <div class="demo-app">
    <SearchFilters
      :showSearchBox="showSearchBox"
      @businessChange="handleBusinessChange"
      @branchChange="handleBranchChange"
      @update:searchQuery="searchQuery = $event"
    />

    <Filters
      :business-id="businessId"
      @update="filters => updatedFilters(filters)"
    />
    <div class="demo-app-main">
      <FullCalendar class="demo-app-calendar" :options="calendarOptions">
      </FullCalendar>
    </div>
    <b-table-simple striped bordered class="mt-3">
      <b-tbody>
        <b-tr>
          <b-td
            >Total Bookings :<b> {{ calendarOptions.events.length }} </b></b-td
          >
          <b-td
            >Total Credit : <b> {{ statistics.credit }}</b>
            <small class="display-6 "> KWD</small></b-td
          >
          <b-td
            >Total Debit : <b> {{ statistics.debit }}</b>
            <small class="display-6 "> KWD</small></b-td
          >
          <b-td
            >Paid : <b> {{ statistics.paidCredit }}</b>
            <small class="display-6 "> KWD</small></b-td
          >
          <b-td
            >Refunded : <b> {{ statistics.refundedDebit }}</b>
            <small class="display-6 "> KWD</small></b-td
          >
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <b-modal
      id="reservation-modal"
      ref="quickReservation"
      size="xl"
      title="QuickRevisions Details"
      centered
      hide-footer
    >
      <QuickReservation
        :business-id="businessId"
        :branch-id="branchId"
        :reservation-date="dateClicked"
        :item="selectedItem"
        :loading="loading"
        @update-loading="updateLoading"
        ref="QuickReservation"
      />
      <!-- <template>
       
      </template> -->
    </b-modal>

    <b-modal ref="modal" size="xl" title="Booking Details" centered hide-footer>
      <ReservationDetails
        v-if="reservation"
        :reservation="reservation"
        :business-id="businessId"
        :branch-id="branchId"
        @closeModal="closeModal"
        @update-reservation="updatedReservation"
      />
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { getAccessToken } from "@/Utils/authentication";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import SearchFilters from "@/components/SearchFilters.vue";
import { core } from "@/config/pluginInit";
import {
  getReservationsFiltered,
  getReservationsList
} from "@/API/ReservationsAPIs";
import moment from "moment";
import Pusher from "pusher-js";
import { PUSHER_KEY, BASE_URL, ENABLE_WS } from "@/config/config";
import ReservationDetails from "./ReservationDetails.vue";
import { getItemsList } from "@/API/ItemsAPIs";
import { StatusColors } from "@/API/BusinessAPIs";
import { InvoiceStatus, InvoiceType } from "@/config/Invoices";
import Filters from "./Filters.vue";
import QuickReservation from "./QuickReservation.vue";
import { filterHolidaysList } from "@/API/HolidaysAPIs";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
const lastMonth = moment().startOf("month");

Vue.prototype.$pusher = new Pusher(PUSHER_KEY, {
  cluster: "ap2",
  authEndpoint: BASE_URL + "/api/pusher/auth",
  auth: {
    headers: {
      Authorization: "Bearer " + getAccessToken(),
      "Access-Control-Allow-Origin": "*"
    }
  }
});

export default {
  name: "ReservationsList",
  components: {
    FullCalendar,
    SearchFilters,
    ReservationDetails,
    Filters,
    QuickReservation
  },

  data() {
    return {
      loading: false,
      showSearchBox: false,
      isEmptylist: false,
      businessId: null,
      branchId: null,
      defaultValues: {},
      itemsList: [],
      reservation: null,
      visibleRange: {
        start: null,
        end: null
      },
      showModal: false,
      tooltipTarget: null,
      tooltipContent: "",
      filter: {},
      calendarOptions: {
        slotLabelFormat: [{ day: "numeric" }, { weekday: "short" }],
        initialDate: lastMonth.format("YYYY-MM-DD"),
        plugins: [resourceTimelinePlugin, interactionPlugin, dayGridPlugin],
        initialView: "resourceTimelineMonth", // Default view
        headerToolbar: {
          left: "prev,next",
          center: "title",
          right: "resourceTimelineMonth,resourceTimelineWeek"
        },
        resourceOrder: 'title',
        resources: [],
        events: [],
        editable: false, // Allow drag-and-drop
        eventResizableFromStart: false, // Allow resizing events
        resourceAreaWidth: "12%", // Adjust the width of the resource list
        slotMinWidth: 40, // Minimum width for time slots

        height: "auto", // Adjust height automatically
        contentHeight: 600, // Set a fixed height for the calendar content
        dayHeaderFormat: {
          day: "numeric", // Display the day number (e.g., 1, 2, 3)
          weekday: "short" // Display the abbreviated weekday name (e.g., Sat, Sun)
        },

        datesSet: info => {
          this.visibleRange = {
            start: info.startStr, // Start of the current view
            end: info.endStr // End of the current view
          };
          this.getReservationsList();
          this.setBackgroundForHolidays(info.startStr, info.endStr);
          this.setBackgroundForWeekend(info.startStr, info.endStr); 
        },
        eventClick: info => {
          this.handleEventClick(info.event);
        },
        dateClick: info => {
          this.handleDateClick(info);
        },
        eventContent: this.renderEventContent,
        eventDidMount: this.handleEventHover
      },
      dateClicked: null,
      selectedItem: null,
      statistics: {
        credit: 0,
        debit: 0,
        paidCredit: 0,
        refundedDebit: 0
      }
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    userBusinesses() {
      return this.$store.state.User.user.business || [];
    },
    userBranches() {
      return this.userBusinesses.find(b => b.id === this.businessId)?.branches || [];
    },
  },
  async mounted() {
    core.index();
    setTimeout(() => this.connectSocket(), 1000);
  },

  methods: {
    async setBackgroundForWeekend(from, to) {
    let startDate = moment(from);
    let endDate = moment(to);
    while (startDate.isSameOrBefore(endDate, 'day')) {
      const dayOfWeek = startDate.day(); 
      if (dayOfWeek === 4 || dayOfWeek === 5 || dayOfWeek === 6) {
        const elements = document.querySelectorAll('[data-date="' + startDate.format("YYYY-MM-DD") + '"]');
        elements.forEach(el => el.style.backgroundColor = "rgba(144, 238, 144, .1)");
      }
      startDate.add(1, 'days');
    }
  },

    async setBackgroundForHolidays(from, to) {
      let holidays = (await filterHolidaysList({businessId: this.businessId, from, to})).data;
      holidays.map((holiday) => {
        const start = moment(holiday.from);
        const end = moment(holiday.to);
        let current = moment(start);
        while (current.isSameOrBefore(end)) {
          const elements = document.querySelectorAll('[data-date="' + moment(current).format("YYYY-MM-DD") + '"]');
          elements.forEach(el => el.style.backgroundColor = "rgba(68,107,204,0.38)");
          current.add(1, 'days');
        }
      })

    },
    updateLoading(newValue) {
      this.loading = newValue;
    },
    renderEventContent(arg) {
      let backgroundColor =
        StatusColors[arg.event.extendedProps.payment_status] ||
        StatusColors["no_data"];
      const eventEl = document.createElement("div");
      eventEl.style.backgroundColor = backgroundColor;
      eventEl.style.padding = "5px";
      eventEl.style.borderRadius = "3px";
      eventEl.innerText = arg.event.title;
      return { domNodes: [eventEl] };
    },
    handleBusinessChange(newValue) {
      if (newValue !== this.businessId) {
        this.businessId = newValue;
      }
    },
    handleBranchChange(newValue) {
      if (newValue !== this.branchId) {
        this.branchId = newValue;
      }
    },
    refreshEvents() {
      this.calendarOptions.events = [];
      this.reservationsList.forEach(reservation => {
        reservation = this.formatReservation(reservation);
        this.calendarOptions.events.push(this.formatEvent(reservation));
      });
    },

    async getReservationsList() {
      if (this.branchId && this.visibleRange.start) {
        this.reservationsList = (
          await getReservationsFiltered({
            branchId: this.branchId,
            businessId: this.businessId,
            from: this.visibleRange.start,
            to: this.visibleRange.end,
            ...this.filter
          })
        ).data;
        this.refreshEvents();
      }

      this.calculateStatistics();
    },

    async getItemsData() {
      if (
        this.itemsList.length === 0 &&
        this.branchId &&
        this.visibleRange.start
      ) {
        this.itemsList = (
          await getItemsList({
            branchId: this.branchId,
            businessId: this.businessId,
            "per-page": 500
          })
        ).data;

        this.calendarOptions.resources = [];
        this.itemsList.forEach(item => {
          let name = "";
          if (item?.itemable?.amount) {
            name = `(${item?.itemable?.amount})`;
          }
          const enLocale = item.locales.find(locale => locale.locale === 'en');
          name += enLocale?.name;
          this.calendarOptions.resources.push({
          id: item.id,
          title: name
        });
        });
      }
    },
    formatReservation(reservation) {
      reservation.created_at = moment(reservation.created_at);
      reservation.from = moment(reservation.from);
      reservation.to = moment(reservation.to);
      return reservation;
    },
    formatEvent(reservation) {
      return {
        id: reservation.id,
        resourceId: reservation.data.reservable?.id,
        title:
          reservation.data.reserved_by?.name +
          " - " +
          reservation.data.reservable.locales.find(
          locale => locale.locale === 'en'
        )?.name,
        start: moment(reservation.from).format("YYYY-MM-DDTHH:mm"),
        end: moment(reservation.to).format("YYYY-MM-DDTHH:mm"),
        status: reservation.status,
        payment_status: reservation.payment_status,
        note: reservation.notes?.length
          ? reservation.notes[reservation.notes.length - 1].text
          : ""
      };
    },
    updatedFilters(filter) {
      this.filter = filter;
      this.getReservationsList();
    },
    refreshEvents() {
      this.calendarOptions.events = [];
      this.reservationsList.forEach(reservation => {
        reservation = this.formatReservation(reservation);
        this.calendarOptions.events.push(this.formatEvent(reservation));
      });
    },

    updatedReservation(reservationData) {
      var resIndex = this.reservationsList.findIndex(
        obj => obj.id === reservationData.id
      );
      this.reservationsList[resIndex] = reservationData;
      let reservation = this.formatReservation(reservationData);
      var objIndex = this.calendarOptions.events.findIndex(
        obj => obj.id === reservation.id
      );
      this.calendarOptions.events[objIndex] = this.formatEvent(reservation);
      this.$set(this.calendarOptions.events, objIndex, {
        ...this.calendarOptions.events[objIndex]
      });
      this.refreshEvents();
    },

    handleEventClick(reservation) {
      this.reservation = this.reservationsList.filter(
        res => res.id === parseInt(reservation.id)
      )[0];
      this.$refs.modal.show();
    },

    handleDateClick(info) {
      this.$bvModal.show("reservation-modal");
      this.dateClicked = info.date;
      var selectedItemId = info.resource.id;
      this.selectedItem = this.itemsList.find(
        item => item.id === parseInt(selectedItemId)
      );
    },
    handleEventHover(info) {
      if (info.event.extendedProps.note || info.event.title) {
    tippy(info.el, {
      content: `
        ${info.event.title ? `<strong>Title: </strong>${info.event.title}<br>` : ''}
        ${info.event.extendedProps.note ? `<strong>Note: </strong>${info.event.extendedProps.note}` : ''}
      `,
      allowHTML: true,
      placement: 'bottom'
    });
  }
    },
    connectSocket() {
      if (ENABLE_WS === "true" && this.branchId) {
        let channelName =
          "private-business-" +
          this.businessId +
          "-branch-" +
          this.branchId +
          "-reservations";
        var channel = this.$pusher.subscribe(channelName);
        channel.bind("new-reservation", response => {
          this.reservationsList.push(response.reservation);
          let reservation = this.formatReservation(response.reservation);
          this.calendarOptions.events.push(this.formatEvent(reservation));
        });
        channel.bind("update-reservation", response => {
          this.updatedReservation(response.reservation);
        });
      }
    },
    closeModal() {
      this.$refs.modal.hide();
    },

    calculateStatistics() {
      this.statistics.credit = 0;
      this.statistics.debit = 0;
      this.statistics.paidCredit = 0;
      this.statistics.refundedDebit = 0;
      if (this.reservationsList?.length > 0) {
        this.reservationsList.forEach(reservation => {
          reservation.data?.invoices?.forEach(invoice => {
            if (invoice.type === InvoiceType.CREDIT) {
              this.statistics.credit += invoice.amount;
              if (invoice.status === InvoiceStatus.PAID)
                this.statistics.paidCredit += invoice.amount;
            }
            if (invoice.type === InvoiceType.DEBIT) {
              this.statistics.debit += invoice.amount;
              if (invoice.status === InvoiceStatus.PAID)
                this.statistics.refundedDebit += invoice.amount;
            }
          });
        });
      }
    }
  },
  watch: {
    businessId(newBusinessID) {
        this.branchId = this.userBranches[0]?.id || null;
      this.getItemsData();
      this.getReservationsList();
    },
    branchId(newBranchId, oldBranchId) {
      if (oldBranchId !== null && newBranchId !== oldBranchId) {
        this.getItemsData();
        this.getReservationsList();
      }
    },
  }
};
</script>

<style lang="scss">
.resources-list {
  .fc-day-thu, .fc-day-fri, .fc-day-sat {
    background-color: #e5ffe599;
  }

  .event-pending {
    background: red;
  }

  .event-canceled {
    background: grey;
  }

  .event-completed {
    background: white !important;
  }

  .hoverable-event {
    cursor: pointer;
  }

  td {
    font-size: 16px;
    text-align: left !important;
  }

}

/* For resource timeline views */
.fc-timeline-lane.fc-resource:hover .fc-timeline-bg {
  background-color: rgba(178, 91, 255, 0.2) !important;
}

.fc .fc-datagrid-cell-cushion {
  font-size: 14px !important;
  font-weight: bold !important;
  white-space: wrap !important;
}

.fc-timeline-slot-frame {
  color: black;
}
.event-container{
  padding: 5px;
  border-radius: 3px;
}
.app-ordered{
  border: #8a2de0 solid 2px;
}
</style>